// Importing React and related hooks
import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
// Importing custom Navbar styles
import "../../styles/common/Navbar.css";
// Importing routing utilities
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState(null);

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    // 🔹 Handle JWT decoding
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded); // Store decoded token in state
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }

    // 🔹 Handle theme-color update
    const primaryColor = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--background-color");
    const secondaryColor = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--secondary-color");

    const metaTag = document.querySelector('meta[name="theme-color"]');
    if (metaTag) {
      metaTag.setAttribute("content", isOpen ? secondaryColor : primaryColor);
    }
  }, [isOpen]);

  return (
    <nav className="navbar navbar-expand-lg mt-3 mx-lg-5 nav-index">
      <div className="container-fluid d-flex justify-content-between">
        {/* Brand/Logo */}
        <a className="navbarBrand" href="/">
          DotDash Academy
        </a>

        {/* Menu toggle for mobile devices */}
        <input
          type="checkbox"
          id="openSideMenu"
          className="openSideMenu"
          checked={isOpen}
          onChange={toggleMenu}
        />
        <label htmlFor="openSideMenu" className="menuIconToggle">
          <div
            className={`hamb-line dia part-1 ${isOpen ? "active" : ""}`}
          ></div>
          <div className={`hamb-line hor ${isOpen ? "active" : ""}`}></div>
          <div
            className={`hamb-line dia part-2 ${isOpen ? "active" : ""}`}
          ></div>
        </label>

        {/* Navigation Menu List */}
        <ul
          className={`menu mx-auto align-item-center mt-lg-3 ${
            isOpen ? "menu-show" : ""
          }`}
          style={{ flexGrow: 1, display: "flex", justifyContent: "center" }}
        >
          <li className="nav-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? "navLink active" : "navLink"
              }
              to="/"
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? "navLink active" : "navLink"
              }
              to="/lessons"
            >
              Lessons
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? "navLink active" : "navLink"
              }
              to="/tutorial"
            >
              Tutorial
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? "navLink active" : "navLink"
              }
              to="/practice"
            >
              Practice
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? "navLink active" : "navLink"
              }
              to="/compare"
            >
              Comparison
            </NavLink>
          </li>

          {/* Logged-In User In-Progress */}
          <li className="nav-item">
            <NavLink
              className={({ isActive }) =>
                isActive ? "navLink active" : "navLink"
              }
              to="/history"
            >
              History
            </NavLink>
          </li>

          {/* Conditionally render Login/Sign Up or Profile */}
          {/* Disabled due to server low up-time */}
          {/* {user ? (
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "navLink active" : "navLink"
                }
                to="/profile"
              >
                Profile
              </NavLink>
            </li>
          ) : (
            <li className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "navLink active" : "navLink"
                }
                to="/login"
              >
                Sign In / Up
              </NavLink>
            </li>
          )} */}
        </ul>

        {/* Profile Icon (Only visible when logged in) */}
        <a className="navLink profile" href="/profile">
          <i className="fas fa-user-circle"></i>
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
